module.exports = __webpack_public_path__ + "img/ycloud-miniprogram-qrcode.46b804d5.png";